import type { TimelineTopicItem } from '../types/topicQuiz';
import { normalizeTopicQuizPlan } from '../types/topicQuiz';

const STORAGE_KEY = 'codelive-topic-planner-topics';
const STORAGE_VERSION_KEY = 'codelive-topic-planner-version';
/** Bump when planner topic shape changes (forces re-import with quiz defaults). */
const STORAGE_VERSION = '9';

export function loadPlannerTopics(): TimelineTopicItem[] {
  try {
    const version = sessionStorage.getItem(STORAGE_VERSION_KEY);
    if (version !== STORAGE_VERSION) {
      sessionStorage.setItem(STORAGE_VERSION_KEY, STORAGE_VERSION);
      sessionStorage.removeItem(STORAGE_KEY);
      return [];
    }
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    return normalizeTopicQuizPlan(JSON.parse(raw) as TimelineTopicItem[]);
  } catch {
    return [];
  }
}

export function savePlannerTopics(topics: TimelineTopicItem[]): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(normalizeTopicQuizPlan(topics)));
}

export function resetPlannerTopics(): TimelineTopicItem[] {
  savePlannerTopics([]);
  return [];
}
